export default {
  endOfLifeCategories: (state) => state.endOfLifeCategories,
  endOfLifeCategorySlugsToIds: (state) => state.endOfLifeCategorySlugsToIds,
  endOfLifeCategoryTree: (state) => state.endOfLifeCategoryTree,
  endOfLifeCategoryItemCounts: (state) => state.endOfLifeCategoryItemCounts,
};
